type ItemLike = { id: number; seq: number; invoiceId: number | null };
type PartLike = { id: number; status: string; splitPlanItemId?: number | null };

export type ScheduleRow<I extends ItemLike, P extends PartLike> = {
  key: string;
  item: I | null;
  part: P | null;
  cancelledOf: { seq: number; replacedBy: P | null } | null;
};

export function scheduleRows<I extends ItemLike, P extends PartLike>(
  planItems: I[],
  parts: P[],
): ScheduleRow<I, P>[] {
  const placed = new Set<number>();
  const rows: ScheduleRow<I, P>[] = [];
  for (const item of [...planItems].sort((a, b) => a.seq - b.seq)) {
    const current = parts.find((p) => p.id === item.invoiceId) ?? null;
    if (current) placed.add(current.id);
    rows.push({ key: `i${item.id}`, item, part: current, cancelledOf: null });
    for (const p of parts) {
      if (
        p.status !== 'cancelled' ||
        p.splitPlanItemId !== item.id ||
        p.id === item.invoiceId
      ) {
        continue;
      }
      placed.add(p.id);
      rows.push({
        key: `p${p.id}`,
        item: null,
        part: p,
        cancelledOf: { seq: item.seq, replacedBy: current },
      });
    }
  }
  for (const p of parts) {
    if (placed.has(p.id)) continue;
    rows.push({ key: `p${p.id}`, item: null, part: p, cancelledOf: null });
  }
  return rows;
}
